import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Differentiators from "@/components/sections/Differentiators";
import Cases from "@/components/sections/Cases";
import About from "@/components/sections/About";
import BrandBanner from "@/components/sections/BrandBanner";
import Contact from "@/components/sections/Contact";

export default function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, []);

  return (
    <main data-testid="home-page" className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <Hero />
      <Services />
      <Differentiators />
      <Cases />
      <About />
      <BrandBanner />
      <Contact />
      <Footer />
    </main>
  );
}
